module.exports = __webpack_public_path__ + "img/Componente 31 – 1.02effb7f.svg";